<template>
  <form @submit.prevent="sendFeedback">
    <div class="relative max-w-2xl" v-if="!hasPermission('update todoitem')">
      <select
        class="block w-full appearance-none bg-gray-100 border-2 border-gray-200 text-gray-700 py-2 m-2 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        id="grid-state"
        v-model="selected"
      >
        <option disabled value="">Selecteer een optie</option>
        <option>{{ this.$route.name }} bestaat niet meer</option>
        <option selected>Gegevens moeten aangepast worden</option>
        <option>Overig</option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>

    <input
      v-else
      type="text"
      v-model="selected"
      placeholder="Titel van opmerking"
      class="block w-full max-w-2xl mb-4 bg-gray-100 pl-4 border-2 border-gray-200"
    />

    <div
      class="relative max-w-2xl"
      v-if="
        hasPermission('update todoitem') && hasPermission('read other users')
      "
    >
      <select
        class="block w-full appearance-none bg-gray-100 border-2 border-gray-200 text-gray-700 py-2 my-2 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        id="grid-state"
        v-model="actor_uuid"
      >
        <option disabled selected value="">Selecteer een optie</option>

        <option :value="user.uuid" v-for="user in users" :key="user.uuid">{{
          user.name
        }}</option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>

    <date-picker
      v-model="deadline"
      placeholder="Selecteer deadline"
      format="DD-MM-YYYY"
      class="feedbackDate"
      v-if="hasPermission('update todoitem')"
    ></date-picker>

    <textarea
      class="block w-full max-w-2xl  mb-4 h-40 bg-gray-100 pl-4 pt-2 border-2 border-gray-200"
      placeholder="Eventuele opmerkingen of aanwijzingen"
      v-model="description"
    ></textarea>

    <div class="relative max-w-2xl">
      <input
        type="submit"
        :disabled="!formDataIsValid"
        value="Verstuur"
        class="mb-4 bg-gray-100 hover:bg-mi-blue-400 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-mi-blue-400 hover:border-transparent rounded"
        :class="{
          'cursor-not-allowed': !formDataIsValid,
          'opacity-50': !formDataIsValid
        }"
      />
    </div>
    <p class="text-red-600 ml-4 mb-2 mt-0">{{ msg }}</p>
  </form>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import { mapGetters } from "vuex";

export default {
  name: "FeedbackForm",
  components: { DatePicker },
  props: ["objectid", "mode", "id"],
  data: () => ({
    msg: "",
    selected: "",
    deadline: null,
    description: "",
    feedbackitem: null, //this is only for edit mode
    actor_uuid: null
  }),
  created: async function() {
    if (this.id) {
      const feedbackitem = await this.$store.dispatch(
        "loadFeedbackItem",
        this.id
      );
      if (feedbackitem) {
        this.description = feedbackitem.description;
        this.selected = feedbackitem.title;
        this.feedbackitem = feedbackitem;
        this.deadline = feedbackitem.deadline
          ? new Date(feedbackitem.deadline)
          : null;
        this.actor_uuid = feedbackitem.actor.id;
      }

      this.$store.dispatch("loadUsers");
    } else {
      this.actor_uuid = this.hasPermission("update todoitem")
        ? this.$store.state.user.id
        : null;
    }
  },
  computed: {
    ...mapGetters({
      users: "users_flattened"
    }),
    formDataIsValid: function() {
      return this.selected && this.description;
    }
  },
  watch: {
    msg(newvalue) {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    }
  },
  methods: {
    parseResponse: function(ok, msg) {
      if (ok) {
        // This event will close this form, so no use in displaying msg
        this.msg = msg;
        this.$emit("feedbackSuccesfullySaved");
      } else {
        this.msg = msg;
      }
    },
    hideMsg: function() {
      this.msg = null;
    },
    addFeedback: async function() {
      let [ok, msg] = await this.$store.dispatch("addFeedback", {
        title: this.selected,
        description: this.description,
        actor: this.actor_uuid,
        deadline: this.deadline,
        object_name: this.$route.name.toLowerCase(),
        object: this.objectid
      });
      //empty form
      this.selected = "";
      this.description = "";
      this.deadline = null;
      this.actor = null;
      if (ok) msg = "Opmerking succesvol verzonden.";
      this.parseResponse(ok, msg);
      // TODO: let's also use parse response
    },
    updateFeedback: async function() {
      const newFeedback = {
        ...this.feedbackitem,
        title: this.selected,
        description: this.description,
        actor: this.actor_uuid,
        creator: this.feedbackitem.creator.id,
        deadline: this.deadline,
        object: this.feedbackitem.object.id,
        object_name: this.$route.name.toLowerCase()
      };
      let [ok, msg] = await this.$store.dispatch("updateFeedback", newFeedback);
      if (ok) msg = "";
      this.parseResponse(ok, msg);
    },
    sendFeedback: function() {
      if (this.mode === "add") {
        this.addFeedback();
      } else if (this.mode === "update") {
        this.updateFeedback();
      }
    }
  }
};
</script>

<style>
.feedbackDate.mx-datepicker .mx-input {
  @apply block w-full max-w-2xl mb-4 bg-gray-100 pl-4 border-2 border-gray-200;
}

.mx-datepicker {
  width: 100%;
}
</style>
